import React from "react";
import { Alert, Box } from "@mui/material";

export function ErrorAlert({
  text,
  onClose,
}: {
  text: string;
  onClose: () => void;
}) {
  return (
    <Box
      sx={{
        position: "absolute",
        left: "50%",
        transform: "translateX(-50%)",
        top: 16,
        zIndex: 1000,
        width: { xs: "90%", sm: "auto" },
        maxWidth: { xs: "400px", sm: "500px" },
      }}
    >
      <Alert variant="filled" severity="error" onClose={onClose}>
        {text}
      </Alert>
    </Box>
  );
}
